export default __webpack_public_path__ + "static/media/paprika_jancsi_etterem_09.af729065.JPG";